import React from "react";
// import { StaticImage } from "gatsby-plugin-image";

// ct
import { sendToCT } from "../../../services/Clevertap";

//styles
import * as styles from "./Inclusion.module.css";

//constant
const accordionPayload = [
  {
    key: "Inclusions-01",
    index: "01",
    icon: <span className="mediumIcon icon-sensor" />,
    title: "Root Cause & Remission",
    desc: "Integration of sensor-based biomarker data & personal preferences.",
    // img: (
    //   <StaticImage
    //     src="../../../images/home/inclusions/sensors.png"
    //     alt="Sensors"
    //     placeholder="blurred"
    //   />
    // ),
    eventName: "Inclusion1_clicked",
    eventDesc: "user clicks on inclusion 1",
  },

  {
    key: "Inclusions-02",
    index: "02",
    icon: <span className="mediumIcon icon-tablet" />,
    title: "Highly Individualized",
    desc: "AI/ML-driven personalized recommendations.",
    // img: (
    //   <StaticImage
    //     src="../../../images/home/inclusions/medicines.png"
    //     alt="Mobile App"
    //     placeholder="blurred"
    //   />
    // ),
    eventName: "Inclusion2_clicked",
    eventDesc: "user clicks on inclusion 2",
  },
  {
    key: "Inclusions-03",
    index: "03",
    icon: <span className="mediumIcon icon-health-coach" />,
    title: "Dynamic & Accountable",
    desc: "Real-time feedback and insights that adapt as metabolism heals.",
    // img: (
    //   <StaticImage
    //     src="../../../images/home/inclusions/health-coach.png"
    //     alt="Health Coach"
    //     placeholder="blurred"
    //   />
    // ),
    eventName: "Inclusion3_clicked",
    eventDesc: "user clicks on inclusion 3",
  },
  {
    key: "Inclusions-04",
    index: "04",
    icon: <span className="mediumIcon icon-chat" />,
    title: "Sustainable",
    desc: "Easier over time, fits within personal preferences and lifestyle.",
    // img: (
    //   <StaticImage
    //     src="../../../images/home/inclusions/consultation.png"
    //     alt="Consultation"
    //     placeholder="blurred"
    //   />
    // ),
    eventName: "Inclusion4_clicked",
    eventDesc: "user clicks on inclusion 4",
  },
  {
    key: "Inclusions-05",
    index: "05",
    icon: <span className="mediumIcon icon-test" />,
    title: "Whole Body Digital Twin Technology ( by AI & ML)",
    desc: "Your WBDTTM plays an essential role by consistently monitoring and analyzing your daily lifestyle choices in order to come up with a plan that is best for you and your metabolism.",
    // img: (
    //   <StaticImage
    //     src="../../../images/home/inclusions/lab-tests.png"
    //     alt="Lab Tests"
    //     placeholder="blurred"
    //   />
    // ),
    eventName: "Inclusion5_clicked",
    eventDesc: "user clicks on inclusion 5",
  },
  {
    key: "Inclusions-06",
    index: "06",
    // icon: <span className="mediumIcon icon-tablet" />,
    icon: <span className="mediumIcon icon-mobile" />,
    title: "Mobile App from Twin Health with health insights",
    desc: "Exclusive access to track your daily health progress, to be in touch with your Care Team, etc.",
    // img: (
    //   <StaticImage
    //     // src="../../../images/home/inclusions/medicines.png"
    //     src="../../../images/home/inclusions/mobile-app.png"
    //     alt="Medicines"
    //     placeholder="blurred"
    //   />
    // ),
    eventName: "Inclusion6_clicked",
    eventDesc: "user clicks on inclusion 6",
  },
  {
    key: "Inclusions-07",
    index: "07",
    icon: <span className="mediumIcon icon-vlock" />,
    title: "Care Team Service",
    desc: "A dedicated professional Health Coach & Doctor to monitor and support your reversal every step of the way.",
    // img: (
    //   <StaticImage
    //     src="../../../images/home/inclusions/monitoring.png"
    //     alt="Monitoring"
    //     placeholder="blurred"
    //   />
    // ),
    eventName: "Inclusion7_clicked",
    eventDesc: "user clicks on inclusion 7",
  },
];

const Accordion = props => {
  return (
    <div
      className="accordion accordion-flush mobAccordion"
      id={"accordionExampleInclusions"}
    >
      <div>
        <hr className={`${styles.darkHr}`} />
      </div>
      {accordionPayload.map((item, index) => (
        <div
          key={index}
          className={`accordion-item bgLightgray ${styles.accordionItem}`}
        >
          <div
            className="accordion-header accordionHeader"
            id={`heading${item.key}`}
          >
            <button
              className={
                index === 0
                  ? `accordion-button d-flex align-items-start justify-content-start ${styles.accordionBtn}`
                  : `accordion-button d-flex align-items-start justify-content-start collapsed  ${styles.accordionBtn}`
              }
              type="button"
              data-bs-toggle={"collapse"}
              data-bs-target={`#collapse${item.key}`}
              aria-expanded={index === 0 ? "true" : "false"}
              aria-controls={`collapse${item.key}`}
              onClick={() =>
                sendToCT(item.eventName, {
                  action: item.eventDesc,
                })
              }
            >
              <div className="col-11 col-md-11 col-lg-11">
                <div className={`row align-items-center ${styles.paddingCo}`}>
                  <div className="col-2 col-md-1 col-lg-1">
                    <span className={`self-align-center ${styles.indexCs}`}>
                      {item.index}
                    </span>
                  </div>
                  <div className="col-2 col-md-1 col-lg-1 ps-2">
                    {item.icon}
                  </div>
                  <div className="col-8 col-md-9 align-self-center col-lg-9 ps-2 pe-4">
                    <p className={`pt-2 ${styles.accordionTitle}`}>
                      {item.title}
                    </p>
                  </div>
                </div>
              </div>
            </button>
          </div>
          <div
            id={`collapse${item.key}`}
            className={
              index === 0
                ? `accordion-collapse collapse show`
                : `accordion-collapse collapse`
            }
            aria-labelledby={`heading${item.key}`}
            data-bs-parent={"#accordionExampleInclusions"}
          >
            <div className={`accordion-body ${styles.noPadding}`}>
              <div className="row">
                <div className="col-4 col-lg-2 col-md-2"></div>
                <div className="col-7 col-md-6 col-lg-6 offset-md-0 offset-lg-0 offset-4 ps-2 ps-md-0 ps-lg-0 mb-3">
                  <p className={`${styles.accordionBody}`}>{item.desc}</p>
                </div>
                <div className="col-8 col-md-4 col-lg-4 offset-md-0 offset-4 pt-4 pt-md-0 pt-lg-0">
                  <div>{item.img}</div>
                </div>
              </div>
            </div>
          </div>
          {index !== accordionPayload.length - 1 && (
            <div className="col-12 col-md-12 col-lg-12">
              <hr className={styles.noMargin} />
            </div>
          )}
        </div>
      ))}

      <hr className={` ${styles.darkHr} ${styles.noMargin}`} />
    </div>
  );
};

export default Accordion;
